import { useEffect } from 'react'
import { HelpCircle, TriangleAlert } from 'lucide-react'

import { Modal } from './Modal'
import { useConfirmStore } from '@/stores/confirm'
import { cn } from '@/lib/utils'

/** confirm() 스토어의 요청을 앱 내장 다이얼로그로 렌더. App 에 한 번만 마운트. */
export function ConfirmDialog() {
  const req = useConfirmStore((s) => s.req)
  const close = useConfirmStore((s) => s.close)

  function answer(ok: boolean) {
    req?.resolve(ok)
    close()
  }

  useEffect(() => {
    if (!req) return
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Enter') { e.preventDefault(); req.resolve(true); close() }
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [req])

  if (!req) return null
  const danger = !!req.danger
  const Icon = danger ? TriangleAlert : HelpCircle

  return (
    <Modal open onClose={() => answer(false)} size="sm" closeOnBackdrop>
      <div className="flex items-start gap-3 pr-6">
        <span className={cn(
          'mt-0.5 grid place-items-center w-9 h-9 rounded-full shrink-0',
          danger ? 'bg-rose-100 text-rose-600' : 'bg-emerald-100 text-emerald-600',
        )}>
          <Icon className="w-5 h-5" strokeWidth={2.2} />
        </span>
        <div className="min-w-0">
          <h3 className="text-base font-bold mb-1 text-slate-900">
            {req.title ?? (danger ? '삭제 확인' : '확인')}
          </h3>
          <p className="text-sm text-slate-600 leading-snug whitespace-pre-line">{req.message}</p>
        </div>
      </div>
      <div className="mt-5 flex justify-end gap-2">
        <button
          onClick={() => answer(false)}
          className="px-4 py-2 text-sm font-semibold text-slate-600 hover:bg-slate-100 rounded-lg transition"
        >
          {req.cancelText ?? '취소'}
        </button>
        <button
          autoFocus
          onClick={() => answer(true)}
          className={cn(
            'px-4 py-2 text-sm font-semibold text-white rounded-lg transition',
            danger ? 'bg-rose-600 hover:bg-rose-700' : 'bg-emerald-600 hover:bg-emerald-700',
          )}
        >
          {req.confirmText ?? (danger ? '삭제' : '확인')}
        </button>
      </div>
    </Modal>
  )
}
